<script>
	export let row;
    export let caseNo; // passed from parent if needed, or derived
</script>

<div>
    {#if row.action === "Create" && row.field === "case_no"}
        <span>
            <b>{row.createdBy}</b> created <b>{caseNo || row.after}</b>
        </span>
    {:else if row.action === "Update" && row.field === "status"}
        {#if row.after === "Closed" && row.closeReason}
            <div>
                <span>
                    <b>{row.createdBy}</b> changed case status from <b>{row.before}</b> to <b>{row.after}.</b>
                </span>
                <br />
                <span>Reason: {row.closeReason}.</span>
            </div>
        {:else}
            <span>
                <b>{row.createdBy}</b> changed case status from <b>{row.before}</b> to <b>{row.after}.</b>
            </span>
        {/if}
    {:else if row.action === "Update" && row.field !== "status" && row.field !== "rejected_reason" && row.field !== "rejected_at"}
        <span>
            <b>{row.createdBy}</b> updated <b>{caseNo || row.caseNo}.</b>
        </span>
    {/if}
</div>
